export default function Mission() {
  return (
    <section id="mission" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/20d64488fbba61fad28d568a2e496d79.jpg" 
                alt="Our Mission" 
                className="w-full h-full object-cover object-center"
              />
            </div>

            <div className="absolute -bottom-6 -right-6 bg-[#D4AF37] rounded-3xl p-8 shadow-2xl max-w-xs">
              <div className="text-white">
                <div className="text-4xl font-bold mb-2">500+</div>
                <div className="text-sm opacity-90">Successful Projects Delivered Across Africa</div>
              </div>
            </div>
          </div>

          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-block bg-[#D4AF37] text-white px-4 py-1.5 rounded-full text-xs font-semibold tracking-wide">
                OUR MISSION
              </div>
              <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Empowering African<br />
                <span className="text-[#D4AF37]">Business Excellence</span>
              </h2>
            </div>

            <div className="space-y-6">
              <p className="text-gray-700 text-base leading-relaxed">
                At ACE Consultancy Africa, our mission is to empower African businesses and individuals with world-class consulting services that drive sustainable growth and success. We believe in the immense potential of the African market and are committed to unlocking opportunities through strategic guidance and innovative solutions.
              </p>

              <p className="text-gray-700 text-base leading-relaxed">
                We strive to be the bridge between ambition and achievement, providing comprehensive services that address the unique challenges and opportunities within the African business landscape. Our approach combines local market expertise with international best practices to deliver exceptional value to our clients.
              </p>

              <div className="bg-[#FAF8F5] rounded-2xl p-8 space-y-4">
                <h4 className="font-bold text-gray-900 text-xl mb-4">Our Core Values</h4>
                
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37] rounded-full flex-shrink-0">
                    <i className="ri-lightbulb-line text-lg text-white"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 mb-1">Innovation</div>
                    <div className="text-sm text-gray-600">Continuously evolving our services to meet changing market needs</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37] rounded-full flex-shrink-0">
                    <i className="ri-shield-check-line text-lg text-white"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 mb-1">Integrity</div>
                    <div className="text-sm text-gray-600">Maintaining the highest ethical standards in all our engagements</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37] rounded-full flex-shrink-0">
                    <i className="ri-trophy-line text-lg text-white"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 mb-1">Excellence</div>
                    <div className="text-sm text-gray-600">Delivering superior results that exceed client expectations</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37] rounded-full flex-shrink-0">
                    <i className="ri-heart-line text-lg text-white"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 mb-1">Client-Centric</div>
                    <div className="text-sm text-gray-600">Putting our clients' success at the heart of everything we do</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
